import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import {
  getPanelErrorProps,
  TextTitle,
  ValidatedPanel,
} from '@bingads-webui-campaign/wizard-jumbo-card';
import { getDescriptionsCardSummaryDetails } from '@bingads-webui-campaign-react/validated-text-collection';
import { DescriptionAssetCollection } from './description-asset-collection';
import TextAssetsImg from '../media/text-assets.svg';

export const DescriptionAssetCollectionSection = React.memo((props) => {
  const {
    featureName, enableCopilotRecommendations, descriptions, expand, setAddNewDescriptionCallback, enableCustomizer, ...rest
  } = props;
  const i18n = useContext(I18nContext);
  const descriptionsCardSummaryDetails = useMemo(() => getDescriptionsCardSummaryDetails(i18n, descriptions), [descriptions, i18n]);

  return (
    <ValidatedPanel
      key="descriptions"
      title={<TextTitle
        titleKey={_TL_('Descriptions')}
        icon={TextAssetsImg}
        iconAltText={i18n.getString(_TL_('Descriptions'))}
        details={descriptionsCardSummaryDetails}
      />}
      attentionBeaconProps={{ getExtraProps: getPanelErrorProps }}
      actuationProps={{
        expand,
        expandKey: 'descriptions',
      }}
      {...rest}
    >
      <DescriptionAssetCollection
        showDeleteButton={enableCopilotRecommendations}
        setAddNewDescriptionCallback={setAddNewDescriptionCallback}
        featureName={featureName}
        enableCopilotRecommendations={enableCopilotRecommendations}
        enableCustomizer={enableCustomizer}
        withDeleteIconDisabled
      />
    </ValidatedPanel>
  );
});

DescriptionAssetCollectionSection.propTypes = {
  featureName: PropTypes.string,
  enableCopilotRecommendations: PropTypes.bool,
  descriptions: PropTypes.shape({}).isRequired,
  expand: PropTypes.func.isRequired,
  setAddNewDescriptionCallback: PropTypes.func.isRequired,
  enableCustomizer: PropTypes.bool,
  withDeleteIconDisabled: PropTypes.bool,
};

DescriptionAssetCollectionSection.defaultProps = {
  featureName: undefined,
  enableCopilotRecommendations: true,
  enableCustomizer: true,
  withDeleteIconDisabled: true,
};
